import { Map } from 'immutable';
import * as relocation from '../../actions/relocation/relocationPersonalDetails';
import {
  STREET_ADDRESS,
  SUBURB,
  STATE,
  COUNTRY,
  POST_CODE,
  PHONE,
  MOBILE,
  STREET_ADDRESS2,
  SUBURB2,
  STATE2,
  COUNTRY2,
  POST_CODE2,
  EMAIL
} from "../../../constants/plaintext/relocationRequest";
const initialState = Map({
  homeDetails:{
    [STREET_ADDRESS]: "",
    [SUBURB]: "",
    [STATE]: "",
    [POST_CODE]: "",
    [COUNTRY]: "",
    [PHONE]:"",
    [MOBILE]:"",
    [STREET_ADDRESS2]: "",
    [SUBURB2]: "",
    [STATE2]: "",
    [POST_CODE2]: "",
    [COUNTRY2]: "",
    [EMAIL]: "",
    isVerify:false,
  },
  AlternateDetailsList: {},
});

const actionsMap = {
  [relocation.UPDATE_ALTERNATE]: (state, action) => {
    return state.set('AlternateDetailsList', action.data);
  },
  [relocation.UPDATE_HOMEDETAILS]: (state, action) => {
    return state.set('homeDetails', action.data);
  },
};

export default function facilities(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}